module.exports = __webpack_public_path__ + "media/audio1.edc430b2.mp3";